import * as React from 'react';
import TabiCubeFooter from './TabiCube';
import Footer from '../../../../../common/Footer';

interface Props {
  /** 旅CUBE版の内容に切り替えるフラグ。 */
  tabiCube?: boolean
}

/** タクシー・ハイヤー予約サービスのフッター。 */
const AirportTransferTaxiFooter: React.FC<Props> = (props: Props) => {
  return (
    <>
      {/* 旅CUBE版の場合。 */}
      { props.tabiCube && <TabiCubeFooter/> }
      {/* 通常（空港アクセスナビ版）の場合。 */}
      { !props.tabiCube && <Footer page='search' /> }
    </>
  );
};

export default AirportTransferTaxiFooter;
